import {useNavigate} from "react-router-dom";
import React, {useContext, useEffect, useState} from "react";

import Meta from "../common/Meta";
import {AppContext} from "../../lib/AppContext";
import ContextSearchNavbar from "../navbars/ContextSearchNavbar";
import DashboardLayout from "../LayoutContainers/DashboardLayout";
import MDBox from "../../components/MDBox";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Footer from "../Footer";
import MDButton from "../../components/MDButton";
import ManageMemberPerkModal from "./modal/ManageMemberPerkModal";
import {archiveMemberPerk, getMemberPerks} from "../common/api/InventoryApi";
import PopupState, {bindMenu, bindTrigger} from "material-ui-popup-state";
import Icon from "@mui/material/Icon";
import Menu from "@mui/material/Menu";
import NotificationItem from "../Items/NotificationItem";
import {Chip} from "@mui/material";
import {CONSTANTS} from "../common/constants";
import {formatCurrency} from "../common/Utils";
import Confirm from "../common/Confirm";

export default function MemberPerks(props) {

  const [context, setContext] = useContext(AppContext);
  const navigate = useNavigate();

  const [managePerk, setManagePerk] = useState(false);
  const [memberPerk, setMemberPerk] = useState(null);

  const manageMemberPerkFn = (perk) => {
    setMemberPerk(perk);
    setManagePerk(true);
  }

  const [memberPerks, setMemberPerks] = useState([]);
  const loadPerks = () => {
    getMemberPerks().then((resp) => {
      setMemberPerks(resp);
    })
  }

  useEffect(() => {
    loadPerks();
  }, [])
  const [confirmation, setConfirmation] = useState(null);
  const [confirmDeleteMemberPerk, setConfirmDeleteMemberPerk] = useState(false);
  const [saving, setSaving] = useState(false);

  const handleArchiveMemberPerk = async (perk) => {
    let result = await archiveMemberPerk(perk);
    if (result.error) {
      setContext({...context, error: {message: result.message}});
    } else {
      setConfirmDeleteMemberPerk(false);
      loadPerks();
    }
  }

  const handleCloseMemberPerk = () => {
    setConfirmDeleteMemberPerk(false);
  };

  const confirmDeleteMemberPerkFn = (perk) => {
    let confirmation = {
      title: 'Archive ' + perk.name + '?',
      message: 'Confirm archive ' + perk.name + '?',
      entity: perk
    }
    setConfirmation(confirmation);
    setConfirmDeleteMemberPerk(true);
  }

  const TaskListActions = ({item}) => {
    return (<PopupState variant="popover" popupId={'inventory-popup-menu-' + item.id}>
      {(popupState) => (
        <>
          <span variant="contained" {...bindTrigger(popupState)}>
            <MDButton
              variant="outlined"
              color="secondary"
              size="small"
              circular
              iconOnly
            >
              <Icon>more_horiz</Icon>
            </MDButton>
          </span>
          <Menu {...bindMenu(popupState)}>
            <NotificationItem
              onClick={(e) => {
                popupState.close();
                manageMemberPerkFn(item)
              }} icon={<Icon>edit</Icon>} title="Edit"/>
            <NotificationItem onClick={(e) => {
              popupState.close();
              confirmDeleteMemberPerkFn(item)
            }} icon={<Icon>delete</Icon>} title="Archive"/>
          </Menu>
        </>
      )}
    </PopupState>);
  }

  return (

    <DashboardLayout>

      <Meta pageTitle={'Member Perks'}/>

      <ContextSearchNavbar title="Member Perks"/>

      <MDBox mt={4}>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={12}>
            <MDBox mb={3}>
              <Card>
                <MDBox p={3}>
                  <h5
                    className={'pull-right'}
                    fontWeight="regular">
                    &nbsp;
                    <MDButton
                      color="secondary"
                      size="small"
                      onClick={(e) => {
                        manageMemberPerkFn();
                      }}>
                      <Icon>check</Icon>&nbsp;Add Member Perk
                    </MDButton>
                    &nbsp;
                  </h5>

                  <p className={'py-2 fw-light'}>
                    Use perks to incentivize and reward members. Perks can be applied to active memberships and may
                    contain discounts, store credit, and product offerings.
                  </p>
                  <ul className={'list-group'}>
                    {memberPerks?.sort((a, b)=> a.id - b.id).map((perk, index) => {
                      return (
                        <li
                          className={'list-group-item'}
                          key={index}>
                          <>
                                <span className="d-block pull-right">
                                    <TaskListActions item={perk}/>
                                  </span>
                            <h5>
                              <a
                                href={'#'}
                                onClick={(e) => {
                                  e.preventDefault();
                                  manageMemberPerkFn(perk);
                                }}>{perk.name}</a>
                            </h5>

                            <p>
                              <small>
                                <b>Type:</b> {perk?.perkType?.name}<br/>
                                {perk?.perkType?.id === CONSTANTS.PERK_TYPE.PRODUCT && <>
                                  <b>Item:</b> {perk.inventory?.name}
                                </>}
                                {perk?.perkType?.id === CONSTANTS.PERK_TYPE.DISCOUNT && <>
                                  <b>Discount:</b> {perk.discountPercentage}%
                                </>}
                                {perk?.perkType?.id === CONSTANTS.PERK_TYPE.CREDIT && <>
                                  <b>Credit:</b> {formatCurrency(perk.storeCreditValue)}
                                </>}<br/>
                                <b>Recurrence:</b> {perk?.recurrenceType?.name}
                                {perk?.timeRestricted && <><br/>
                                  <b>Expires in:</b> {perk?.expirationDays} days
                                </>}
                                <br/>
                                <b>Unlimited:</b> {perk?.unlimitedUsage ? 'Yes' : 'No'}
                                </small>
                            </p>

                          </>

                          {perk?.assignedInventoryMemberships?.length > 0 &&
                            <div>
                              <p className={'m-0'}><b>Assigned Memberships</b></p>
                              {perk?.assignedInventoryMemberships?.sort((a, b) => a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1).map((m, idx) => {
                                return (
                                  <span key={idx}>
                                      <Chip className={'my-1'} variant="outlined" label={m.name}/>&nbsp;
                                  </span>
                                )
                              })}
                            </div>
                          }

                          {perk?.perkType?.id === CONSTANTS.PERK_TYPE.DISCOUNT && perk?.assignedInventoryTypes?.length > 0 &&
                            <div className={'mt-2'}>
                              <p className={'m-0'}><b>Discount Inventory Types</b></p>
                              {perk?.assignedInventoryTypes?.sort((a, b) => a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1).map((m, idx) => {
                                return (
                                  <span key={idx}>
                                      <Chip className={'my-1'} variant="outlined" label={m.name}/>&nbsp;
                                  </span>
                                )
                              })}
                            </div>
                          }

                          {perk.description && <>
                            <p className={'m-0'}>
                              <b>Description</b></p>
                            <div style={{
                              marginLeft:'5px',
                              paddingLeft:'10px',
                              borderLeft:'solid 4px #ddd'
                            }}>
                              <small className={'text-small mt-n2'} style={{
                                whiteSpace:'pre-wrap'
                              }}>{perk.description}</small>
                            </div>
                          </>
                          }

                        </li>
                      );
                    })}
                  </ul>
                </MDBox>
              </Card>
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>

      <Footer mt={5}/>

      {managePerk && <ManageMemberPerkModal
        handleSave={(data) => {
          setManagePerk(false);
          loadPerks();
        }}
        show={managePerk} perk={memberPerk} handleClose={() => {
        setManagePerk(false);
        setMemberPerk(null);
      }}/>}

      {confirmDeleteMemberPerk && <Confirm confirmation={confirmation}
                                             show={confirmDeleteMemberPerk}
                                             saving={saving}
                                             handleConfirm={handleArchiveMemberPerk}
                                             handleClose={handleCloseMemberPerk}
                                             handleSave={handleCloseMemberPerk} />}

    </DashboardLayout>

  );
}